/**
 * Legacy consolidated entry point.
 * This file merges the former index.js, main.js, and product.js entry points
 * into a single bundle (legacy.min.js) loaded on all non-checkout pages.
 *
 * Source files are frozen under src/scripts/deprecated/ — do not add new
 * features here; migrate to src/scripts/app.js (Alpine / Web Components stack).
 */

import '@babel/polyfill/noConflict'
import 'unfetch/polyfill'
import 'lib/filters'
import 'lib/accessibility'
import { isTouchDevice } from 'lib/util'
import klaviyoForms from 'lib/klaviyo-forms'
import initializer from 'lib/initializer'

// ─── Vue Components ────────────────────────────────────────────────────────────
// Account
import 'modules/account-address-item/account-address-item.vue'
import 'modules/account-login-form/account-login-form.vue'
import 'modules/account-new-address/account-new-address.vue'
import 'modules/account-recover-form/account-recover-form.vue'
import 'modules/account-register-form/account-register-form.vue'
import 'modules/checkbox/checkbox.vue'
import 'modules/select-input/select-input.vue'
import 'modules/text-input/text-input.vue'
// Cart / shared
import 'modules/cart-gift-message/cart-gift-message.vue'
import 'modules/cart-grid/cart-grid.vue'
import 'modules/newsletter-form/newsletter-form.vue'
import 'modules/size-selector/size-selector.vue'
// Product
import 'modules/product-card/product-card.vue'
import 'modules/product-card-price-line/product-card-price-line.vue'
import 'modules/product-description/product-description.vue'
import 'modules/product-recently-viewed/product-recently-viewed.vue'
import 'modules/yotpo-bottomline/yotpo-bottomline.vue'

// ─── JS-Defined Components ─────────────────────────────────────────────────────
import aboutHistory from 'modules/about-history/about-history'
import accountAddress from 'modules/account-address/account-address'
import accountForms from 'modules/account-forms/account-forms'
import basicPage from 'modules/basic-page/basic-page'
import breadcrumbs from 'modules/breadcrumbs/breadcrumbs'
import bundleProductList from 'modules/bundle-products-list/bundle-products-list'
import cartGrid from 'modules/cart-grid/cart-grid'
import countdownRow from 'modules/countdown-row/countdown-row'
import featuredProducts from 'modules/featured-products/featured-products'
import halfCols from 'modules/half-cols/half-cols'
import header from 'modules/header/header'
import headerSearch from 'modules/header-search/header-search'
import image from 'modules/image/image'
import newsletterForm from 'modules/newsletter-form/newsletter-form'
import pairsWellWith from 'modules/pairs-well-with/pairs-well-with'
import pdpLargeImage from 'modules/pdp-large-image/pdp-large-image'
import pdpQuotes from 'modules/pdp-quotes/pdp-quotes'
import pdpSimpleIngredients from 'modules/pdp-simple-ingredients/pdp-simple-ingredients'
import pdpUsVsThem from 'modules/pdp-us-vs-them/pdp-us-vs-them'
import productCustomBundle from 'modules/product-custom-bundle/product-custom-bundle'
import productForm from 'modules/product-form/product-form'
import productGalleryNew from 'modules/product-gallery-new/product-gallery-new'
import productStickyNav from 'modules/product-sticky-nav/product-sticky-nav'
import recentlyViewed from 'modules/recently-viewed/recently-viewed'
import yotpoReviewsNew from 'modules/yotpo-reviews-new/yotpo-reviews-new'

document.addEventListener('DOMContentLoaded', () => {
  initializer({
    // Layout / nav
    header: header,
    'header-search': headerSearch,
    // General
    image: image,
    'half-cols': halfCols,
    'basic-page': basicPage,
    'about-history': aboutHistory,
    'countdown-row': countdownRow,
    'featured-products': featuredProducts,
    // Account
    'account-address': accountAddress,
    'account-forms': accountForms,
    // Cart
    'cart-grid': cartGrid,
    'newsletter-form': newsletterForm,
    // Product
    breadcrumbs: breadcrumbs,
    'bundle-product-list': bundleProductList,
    'pairs-well-with': pairsWellWith,
    'pdp-large-image': pdpLargeImage,
    'pdp-quotes': pdpQuotes,
    'pdp-simple-ingredients': pdpSimpleIngredients,
    'pdp-us-vs-them': pdpUsVsThem,
    'product-custom-bundle': productCustomBundle,
    'product-form': productForm,
    'product-gallery-new': productGalleryNew,
    'product-sticky-nav': productStickyNav,
    'recently-viewed': recentlyViewed,
    'yotpo-reviews-new': yotpoReviewsNew,
  })

  if (isTouchDevice()) {
    document.body.classList.remove('no-touch')
  }
  klaviyoForms()
})
